var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Card", {
        attrs: { title: "Detail Artist" },
        scopedSlots: _vm._u([
          {
            key: "button",
            fn: function() {
              return [
                _c("Button", {
                  attrs: { variant: "default", label: "Back" },
                  on: { clicked: _vm.goBack }
                }),
                _vm._v(" "),
                _vm.$route.query.fromDraft == undefined
                  ? _c("Button", {
                      attrs: {
                        variant: "primary",
                        label: "Download Statement"
                      },
                      on: { clicked: _vm.download }
                    })
                  : _vm._e()
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _c("div", { staticClass: "w-full" }, [
                  _c(
                    "ul",
                    {
                      staticClass:
                        "flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row"
                    },
                    [
                      _vm.$route.query.fromDraft == undefined
                        ? _c(
                            "li",
                            {
                              staticClass:
                                "-mb-px mr-2 last:mr-0 flex-auto text-center cursor-pointer "
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    " text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal",
                                  class: {
                                    "text-blue-500 bg-white":
                                      _vm.detailArtistOpenTab !== 1,
                                    "text-white bg-blue-500":
                                      _vm.detailArtistOpenTab === 1
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleTabsArtistDetail(1)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              Profile\n            "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$route.query.fromDraft == undefined
                        ? _c(
                            "li",
                            {
                              staticClass:
                                "-mb-px mr-2 last:mr-0 flex-auto text-center cursor-pointer "
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal",
                                  class: {
                                    "text-blue-500 bg-white":
                                      _vm.detailArtistOpenTab !== 2,
                                    "text-white bg-blue-500":
                                      _vm.detailArtistOpenTab === 2
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleTabsArtistDetail(2)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              Song List\n            "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$route.query.fromDraft == undefined
                        ? _c(
                            "li",
                            {
                              staticClass:
                                "-mb-px mr-2 last:mr-0 flex-auto text-center cursor-pointer "
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal",
                                  class: {
                                    "text-blue-500 bg-white":
                                      _vm.detailArtistOpenTab !== 3,
                                    "text-white bg-blue-500":
                                      _vm.detailArtistOpenTab === 3
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleTabsArtistDetail(3)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              Album List\n            "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded"
                    },
                    [
                      _c("div", { staticClass: "px-4 py-5 flex-auto" }, [
                        _c("div", { staticClass: "tab-content tab-space" }, [
                          _c(
                            "div",
                            {
                              staticClass: "mx-400 overflow-y-auto",
                              class: {
                                hidden: _vm.detailArtistOpenTab !== 1,
                                block: _vm.detailArtistOpenTab === 1
                              }
                            },
                            [
                              _c("ArtistProfile", {
                                ref: "artist-profile",
                                attrs: { user: _vm.getArtist },
                                on: { "on-save": _vm.onSaveProfile }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "mx-400 overflow-y-auto",
                              class: {
                                hidden: _vm.detailArtistOpenTab !== 2,
                                block: _vm.detailArtistOpenTab === 2
                              }
                            },
                            [
                              _c("ListSong", {
                                attrs: {
                                  artistid: _vm.artistId,
                                  "toggle-reset": true,
                                  "musicverse-cut":
                                    _vm.getArtist.musicverse_cut,
                                  "artist-cut": _vm.getArtist.artist_cut
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "mx-400 overflow-y-auto",
                              class: {
                                hidden: _vm.detailArtistOpenTab !== 3,
                                block: _vm.detailArtistOpenTab === 3
                              }
                            },
                            [
                              _c("ListAlbum", {
                                attrs: {
                                  artistid: _vm.artistId,
                                  "toggle-reset": true,
                                  "musicverse-cut":
                                    _vm.getArtist.musicverse_cut,
                                  "artist-cut": _vm.getArtist.artist_cut
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ]
                  )
                ])
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63b354e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63b354e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ArtistContent/ArtistDetail.vue
// module id = null
// module chunks = 